import { render, staticRenderFns } from "./indicacao.vue?vue&type=template&id=cf1cdb32"
import script from "./indicacao.vue?vue&type=script&lang=js"
export * from "./indicacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports